module.exports = __webpack_public_path__ + "static/media/eventsBackground.e769a1f0.jpg";